import React, { Component, Fragment } from 'react';
import { Redirect, withRouter } from "react-router-dom";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroupItem from 'react-bootstrap/ListGroupItem';
import AssessmentResults from './AssessmentResults';
import ChangeOwnerModal from './ChangeOwnerModal';
import ChangeAssessmentProfileModal from './ChangeAssessmentProfileModal';
import authService from '../../services/AuthService';

import expandIcon from '../../content/ExpandIcon.png';
import collapseIcon from '../../content/CollapseIcon.png';

import './Home.css';

class PersonListItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: null, 
            active: this.props.active,
            expanded: this.props.active,
            changeOwnerModalShow: false,
            changeAssessmentModalShow: false
        }
    }

    openChangeOwnerModal = (e) => {
        this.setState({ changeOwnerModalShow: true });
        e.stopPropagation();
        return;
    }

    closeChangeOwnerModal = (reloadPage) => {
        if (reloadPage) {
            this.props.changeOwnershipHandler();
        }
        else {
            this.setState({ changeOwnerModalShow: false });
        }
    }

    openChangeAssessmentProfileModal = (e) => {
        this.setState({ changeAssessmentProfileModalShow: true });
        e.stopPropagation();
        return;
    }

    closeChangeAssessmentProfileModal = (reloadPage) => {
        if (reloadPage) {
            this.props.changeAssessmentProfileHandler();
        }
        else {
            this.setState({ changeAssessmentProfileModalShow: false });
        }
    }

    assessmentCreationHandler = (fn, ln, bd, pId) => {
        this.props.assessmentCreationHandler(fn, ln, bd, pId);
    }

    assessmentSearchHandler = (fn, ln, bd, pId) => {
        this.props.assessmentSearchHandler(fn, ln, bd, pId);
    }

    assessmentSelectionHandler = (aId, assessmentDate) => {
        this.props.assessmentSelectionHandler(aId, assessmentDate);
        this.props.history.replace('/cade');
    }

    redirectToProfile = () => {
        this.setState({ redirect: "/profile" });
    }

    expandCollapseHandler = (event) => {
        if (event.target.classList && event.target.classList.contains("home_noExpandCollapse")) {
            // Text, checkboxes and other controls should not cause expand/collapse reaction.  Could not seem to stopPropagation so using this method.
            return;
        }
        this.setState({ expanded: !this.state.expanded });
    }

    render = () => {
        if (this.state.redirect != null) {
            let state = { userDisplayName: this.props.userDisplayName, tabToDisplay: "paymentTab" };
            return <Redirect to={{
                pathname: this.state.redirect, state: {...state} }
            }/>
        }

        let redirectToProfile = false;
        let canCopyAssessment = true;
        let createText = null;
        if (this.props.payPerUseRemaining == 999) {
            createText = "Create New Assessment";
        }
        else if (this.props.payPerUseRemaining > 1) {
            createText = "Create New Assessment (" + this.props.payPerUseRemaining + " remaining)";
        }
        else if (this.props.payPerUseRemaining == 1) {
            createText = "Create New Assessment (ONLY " + this.props.payPerUseRemaining + " REMAINING)";
        }
        else if (this.props.payPerUseRemaining == 0 && this.props.payPerUseGraceQuantity > 0) {
            createText = "Create New Assessment (" + this.props.payPerUseRemaining + " REMAINING!)";
        }
        else if (this.props.payPerUseRemaining < 0) {
            createText = "Add More Assessments";
            redirectToProfile = true;
            canCopyAssessment = false;
        }

        // TURNING OFF COPY ASSESSMENT FOR NOW UNTIL MARKETING CAN DECIDE ON REQUIREMENTS
        canCopyAssessment = false;

        // Expand/Collapse is independent from active (meaning the assessments are loaded)
        let expandCollapseIcon = null;
        let expandCollapseClass = null;
        if (this.state.expanded) {
            expandCollapseIcon = collapseIcon;
            expandCollapseClass = "expanded";
        }
        else {
            expandCollapseIcon = expandIcon;
            expandCollapseClass = "collapsed";
        }

        // Active means we have loaded the assessments already and further clicks should be simply open/close; conversely, not active means that the item needs to get loaded through the search handler.
        let groupListClickHandler = null;
        if (this.state.active) {
            groupListClickHandler = this.expandCollapseHandler;
        }
        else {
            groupListClickHandler = this.assessmentSearchHandler.bind(this, this.props.firstName, this.props.lastName, this.props.birthDate, this.props.providerId)
        }

        let childPatient = (authService.isParentAccount) ? "child" : "patient";
        let personAssessments = this.props.personAssessments;
        let assessmentId = (personAssessments.length > 0) ? personAssessments[0].id : 0;

        return (
            <Fragment>

                <ListGroupItem
                    key={this.props.encPerson}
                    onClick={groupListClickHandler}
                    active={this.state.expanded}
                    className={expandCollapseClass}
                >
                    <Row>
                        <Col sm={2}>
                            <img className="home_expandCollapseIcon" src={expandCollapseIcon} />
                            <span className="home_personListItemText">{this.props.lastName}</span>
                        </Col>
                        <Col sm={2}>
                            <span className="home_personListItemText">{this.props.firstName}</span>
                        </Col>
                        <Col sm={2}>
                            <span className="home_personListItemText">{this.props.birthDate}</span>
                        </Col>
                        <Col sm={6}>
                            <Row>
                                <Col sm={12}>
                                    {!this.props.canCreateAssessment &&
                                        <span className="home_personListItemTextExtra">{this.props.ownerName}</span>
                                    }
                                    {this.props.canCreateAssessment && redirectToProfile &&
                                        <Button className="home_createAssessmentButton" variant="primary" size="sm" onClick={this.redirectToProfile}>{createText}</Button>
                                    }
                                    {this.props.canCreateAssessment && !redirectToProfile &&
                                        <Button className="home_createAssessmentButton" variant="primary" size="sm" onClick={this.assessmentCreationHandler.bind(this, this.props.firstName, this.props.lastName, this.props.birthDate, this.props.providerId)}>{createText}</Button>
                                    }
                                </Col>
                                <Col sm={7}>
                                    {this.props.canCreateAssessment && this.state.expanded && 
                                        <Button className="home_createAssessmentButton" variant="secondary" size="sm" onClick={this.openChangeOwnerModal}>Change Owner to Another CADE User</Button>
                                    }
                                </Col>
                                <Col sm={5}>
                                    {this.props.canCreateAssessment && this.state.expanded &&
                                        <Button className="home_createAssessmentButton" variant="secondary" size="sm" onClick={this.openChangeAssessmentProfileModal}>Change {childPatient} Info</Button>
                                    }
                                </Col>
                            </Row>
                        </Col>
                            
                        {this.state.expanded &&
                            <AssessmentResults
                                firstName={this.props.firstName}
                                lastName={this.props.lastName}
                                birthDate={this.props.birthDate}
                                personAssessments={this.props.personAssessments}
                                assessmentSelectionHandler={this.assessmentSelectionHandler}
                                assessmentDeleteHandler={this.props.assessmentDeleteHandler}
                                assessmentCopyHandler={this.props.assessmentCopyHandler}
                                canCopyAssessment={canCopyAssessment}
                                providerId={this.props.providerId}
                                isCaregiver={authService.isCaregiver}
                            />
                        }

                    </Row>
                    
                </ListGroupItem>
                <ChangeOwnerModal
                    providerId={this.props.providerId}
                    firstName={this.props.firstName}
                    lastName={this.props.lastName}
                    birthDate={this.props.birthDate}
                    show={this.state.changeOwnerModalShow}
                    closeHandler={this.closeChangeOwnerModal}
                    key={this.state.changeOwnerModalShow}
                />
                <ChangeAssessmentProfileModal
                    assessmentId={assessmentId}
                    firstName={this.props.firstName}
                    lastName={this.props.lastName}
                    birthDate={this.props.birthDate}
                    show={this.state.changeAssessmentProfileModalShow}
                    closeHandler={this.closeChangeAssessmentProfileModal}
                    key={new Date().getMilliseconds()}
                />
            </Fragment>
        )
    }
}

export default withRouter(PersonListItem);


// WEBPACK FOOTER //
// ./src/components/Home/PersonListItem.js